import { Injectable } from '@angular/core';

@Injectable()
export class OrderByService {

  private _ascending : boolean = true;
  private _orderType : number = 0;
  private _orderFor : string = 'plant';

  constructor() { }

  get ascending() {
    return this._ascending;
  }
  set ascending(value: boolean) {
    this._ascending = value;
  }

  get orderType() {
    return this._orderType;
  }
  set orderType(value: number) {
    this._orderType = value;
  }

  get orderFor() : string {
    return this._orderFor;
  }

  set orderFor(value:string) {
    this._orderFor = value;
  }

  reset() {
    this.ascending = true;
    this.orderType = 0;
    this.orderFor = 'plant';
  }

}
